import { render, staticRenderFns } from "./AdvertisementForm.vue?vue&type=template&id=36537d42"
import script from "./AdvertisementForm.vue?vue&type=script&lang=js"
export * from "./AdvertisementForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports